import {
  Box,
  Flex,
  SlideFade,
  Stack,
  Text,
  Badge,
  useColorModeValue,
  Image,
  Center,
  VStack,
  Select,
} from "@chakra-ui/react";
import "pure-react-carousel/dist/react-carousel.es.css";
import dayjs from "dayjs";
import { COLORS } from "../../../constants/colors";
import { PROTECTED_PATHS } from "../../../app/constants";
import { transition } from "../../..";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Footer from "../../../components/footer";
import { ConfirmPaymentModal } from "./ConfirmPaymentModal";
import { useContext, useEffect, useState } from "react";
import { getDueTypes } from "../service";
import { AuthContext } from "../../../context/authContext";
import FullPageLoader from "../../../components/FullPageLoader";
import {
  errorNotifier,
  infoNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import {
  verifyPayment,
} from "../../estateDue/service";



const EstateBills = () => {
  const FREQUENCY_OPTIONS = [
    { label: "All Frequencies", value: "All" },
    { label: "One Time", value: "one-time" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
  ];
  const [dueTypes, setDueTypes] = useState([]);
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [frequencyFilter, setFrequencyFilter] = useState("All");
  const { userInfo } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const { userId } = userInfo;
  const pageBg = useColorModeValue(COLORS.bgGrey, COLORS.darkModeBg);
  const TransBg = useColorModeValue(COLORS.primary, COLORS.chartbg);
  const cardBg = useColorModeValue(COLORS.lightGrey, COLORS.white);
  const { MY_WALLET } = PROTECTED_PATHS;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const frequencyParam = frequencyFilter === "All" ? null : frequencyFilter;
        const response = await getDueTypes(userId, setLoading, setDueTypes, frequencyParam);
        if (response?.data?.result?.data?.totalPendingAmount) {
          setTotalPendingAmount(response.data.result.data.totalPendingAmount);
        }
      } catch (error) {
        errorNotifier("An error occurred while fetching data.");
      }
    };
    fetchData();
  }, [userId, frequencyFilter]);

  return loading ? (
    <FullPageLoader />
  ) : (
    <SlideFade in={true} offsetY="500px" {...transition}>
      <Stack pb="15vh" w={"100%"} overflowX={"hidden"}>
        <Stack bg={pageBg} my="20px">
          <Container>
            <Header goto={MY_WALLET} />
          </Container>
        </Stack>
        <Container>
          <Box mb="20px">
            <Select
              value={frequencyFilter}
              onChange={(e) => setFrequencyFilter(e.target.value)}
              bg={COLORS.white}
              color={TransBg}
            >
              {FREQUENCY_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </Box>

          {!dueTypes || dueTypes.length === 0 ? (
            <Center h="calc(100vh - 150px)">
              <VStack>
                <Image src="/Empty.svg" alt="Empty" />
                <Text as="h2" py="5" fontSize="18px" color={cardBg}>
                  You have no estate bills
                </Text>
              </VStack>
            </Center>
          ) : (
            <>
              {dueTypes.length > 0 ? (
                dueTypes.map((datum, index) => (
                  <Box key={index} bg={TransBg} p="15px" rounded="lg" mb="20px">
                    <Flex justify="space-between" mb="20px">
                      <Text color={cardBg}>{datum?.type || "--"} <Badge fontSize={"0.5rem"} textTransform="none">{(datum?.frequency || "--")?.toLowerCase()}</Badge></Text>
                      <Text color={cardBg}>
                        &#8358; {(datum?.amount || "--")?.toLocaleString()}
                      </Text>
                    </Flex>
                    <Flex justify="space-between" align="center">
                      <Text color={COLORS.lightGrey}>
                        {dayjs(datum?.updatedAt).format("DD MMM YYYY") || "--"}
                      </Text>

                      <ConfirmPaymentModal
                        dueTypes={datum}
                        totalPendingAmount={totalPendingAmount}
                      />
                    </Flex>
                  </Box>
                ))
              ) : (
                <Text color={COLORS.gray} fontSize="sm">
                  No bills available for this frequency.
                </Text>
              )}
            </>
          )}
        </Container>

        <Footer />
      </Stack>
    </SlideFade>
  );
};

export default EstateBills;